// extracted by mini-css-extract-plugin
module.exports = {"operation":"wZcQnKVH","button":"txIgTRFc","share":"__87jglBI9","icon":"BfSy6_Gv","active":"vM__H0el","reverse":"cCpIH2eZ","remix":"WyLdJxoq"};